import { TravelTypes } from '../../constants';
// eslint-disable-next-line import/extensions
import { CarRate, CarRateBreakdown } from '../../types/rentalCar';
import checkDoShowMarkupRates from './checkDoShowMarkupRates';

const getRentalCarRate = ({
  reduxState, tripId, trip, rate, doShowMarkupRate = undefined, itineraryId = 0,
}: {
  reduxState?: any, tripId?: string, trip?: any;
  rate: CarRateBreakdown; doShowMarkupRate?: boolean, itineraryId?: any,
}): CarRate => {
  const doShowMarkup = doShowMarkupRate === undefined
    ? checkDoShowMarkupRates({
      mode: TravelTypes.carrental, tripId, trip, itineraryId,
    })(reduxState) : doShowMarkupRate;
  if (doShowMarkup) {
    return {
      price: rate.markupPrice,
      currencyCode: rate.currencyCode,
      priceWithoutPackage: 0,
      markupPriceAllDays: rate.markupPriceAllDays,
      priceAllDays: rate.priceAllDays,
      vehicleCharges: rate.vehicleCharges,
    };
  }
  return {
    price: rate.price,
    currencyCode: rate.currencyCode,
    priceWithoutPackage: rate.price !== rate.markupPrice ? rate.markupPrice : 0,
    markupPriceAllDays: rate.markupPriceAllDays,
    priceAllDays: rate.priceAllDays,
    vehicleCharges: rate.vehicleCharges,
  };
};

export default getRentalCarRate;
